import { render, staticRenderFns } from "./NftSwapAccount.vue?vue&type=template&id=aa5a9fca&scoped=true&"
import script from "./NftSwapAccount.vue?vue&type=script&lang=ts&"
export * from "./NftSwapAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5a9fca",
  null
  
)

export default component.exports